import React from 'react';
import { TrendingDown, AlertTriangle, Wallet } from 'lucide-react';
export function Problem() {
  return <section className="py-20 bg-slate-900 relative border-y border-slate-800" data-id="element-110">
      <div className="container mx-auto px-4" data-id="element-111">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-112">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-113">
            El Techo de Cristal de los Pesos
          </h2>
          <div className="w-24 h-1 bg-red-500/50 mx-auto rounded-full mb-8" data-id="element-114"></div>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-115">
          <div className="bg-slate-950 p-8 rounded-2xl border border-slate-800 hover:border-red-500/30 transition-colors group" data-id="element-116">
            <div className="w-14 h-14 bg-red-500/10 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform" data-id="element-117">
              <TrendingDown className="w-7 h-7 text-red-400" data-id="element-118" />
            </div>
            <h3 className="text-xl font-bold text-white mb-4" data-id="element-119">
              Tu sueldo se licúa
            </h3>
            <p className="text-slate-400 leading-relaxed" data-id="element-120">
              Trabajar 8 horas para llegar con lo justo no es vida. En
              Argentina, tu esfuerzo vale menos cada mes por culpa de la
              inflación.
            </p>
          </div>

          <div className="bg-slate-950 p-8 rounded-2xl border border-slate-800 hover:border-orange-500/30 transition-colors group md:-translate-y-4" data-id="element-121">
            <div className="w-14 h-14 bg-orange-500/10 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform" data-id="element-122">
              <AlertTriangle className="w-7 h-7 text-orange-400" data-id="element-123" />
            </div>
            <h3 className="text-xl font-bold text-white mb-4" data-id="element-124">
              El mercado local está roto
            </h3>
            <p className="text-slate-400 leading-relaxed" data-id="element-125">
              Los clientes locales no pueden pagar lo que realmente vale tu
              trabajo. Estás compitiendo por migajas en un mercado devaluado.
            </p>
          </div>

          <div className="bg-slate-950 p-8 rounded-2xl border border-slate-800 hover:border-purple-500/30 transition-colors group" data-id="element-126">
            <div className="w-14 h-14 bg-purple-500/10 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform" data-id="element-127">
              <Wallet className="w-7 h-7 text-purple-400" data-id="element-128" />
            </div>
            <h3 className="text-xl font-bold text-white mb-4" data-id="element-129">
              La trampa del peso
            </h3>
            <p className="text-slate-400 leading-relaxed" data-id="element-130">
              Es hora de dejar de cobrar en una moneda que pierde valor y
              empezar a facturar en la moneda más fuerte del mundo.
            </p>
          </div>
        </div>
      </div>
    </section>;
}